import { render, staticRenderFns } from "./browse.vue?vue&type=template&id=56508600"
import script from "./browse.vue?vue&type=script&lang=js"
export * from "./browse.vue?vue&type=script&lang=js"
import style0 from "./browse.vue?vue&type=style&index=0&id=56508600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports